import routeName from './constant';
import { isProdMode } from '@/utils/is';

let uatRoutes = [{
    path: '/',
    component: () => import('@/components/routerView/LayoutHearder.vue'),
    children: [
        {
            path: 'SSOInput',
            name: routeName.SSOInput,
            component: () => import('@/views/login/SSOInput.vue'),
            meta: {
                auth: false,
                metaTitle: '單一登入首頁',
                pageTitle: '單一登入首頁',
            },
        },
        {
            path: 'SSOInputA1',
            name: routeName.SSOInputA1,
            component: () => import('@/views/login/SSOInputA1.vue'),
            meta: {
                auth: false,
                metaTitle: '單一登入A1',
                pageTitle: '單一登入A1',
            },
        },
        {
            path: 'SSOInputA3',
            name: routeName.SSOInputA3,
            component: () => import('@/views/login/SSOInputA3.vue'),
            meta: {
                auth: false,
                metaTitle: '單一登入A3',
                pageTitle: '單一登入A3',
            },
        },
        {
            path: 'SSOInputA4',
            name: routeName.SSOInputA4,
            component: () => import('@/views/login/SSOInputA4.vue'),
            meta: {
                auth: false,
                metaTitle: '單一登入A4',
                pageTitle: '單一登入A4',
            },
        },
        {
            path: 'SSOInputA5',
            name: routeName.SSOInputA5,
            component: () => import('@/views/login/SSOInputA5.vue'),
            meta: {
                auth: false,
                metaTitle: '單一登入A5',
                pageTitle: '單一登入A5',
            },
        },
        {
            path: 'SSOInputA6',
            name: routeName.SSOInputA6,
            component: () => import('@/views/login/SSOInputA6.vue'),
            meta: {
                auth: false,
                metaTitle: '單一登入A6',
                pageTitle: '單一登入A6',
            },
        },
        {
            path: 'SSOInputCamFrom3',
            name: routeName.SSOInputCamFrom3,
            component: () => import('@/views/login/SSOInputCamFrom3.vue'),
            meta: {
                auth: false,
                metaTitle: '變更效期',
                pageTitle: '變更效期',
            },
        },
        {
            path: 'SSOInputCamFrom4',
            name: routeName.SSOInputCamFrom4,
            component: () => import('@/views/login/SSOInputCamFrom4.vue'),
            meta: {
                auth: false,
                metaTitle: '金融機構轉帳',
                pageTitle: '金融機構轉帳',
            },
        },
        {
            path: 'SSOInputCamFrom5',
            name: routeName.SSOInputCamFrom5,
            component: () => import('@/views/login/SSOInputCamFrom5.vue'),
            meta: {
                auth: false,
                metaTitle: '自行繳費',
                pageTitle: '自行繳費',
            },
        },
        {
            path: 'SSOInputCamFrom6',
            name: routeName.SSOInputCamFrom6,
            component: () => import('@/views/login/SSOInputCamFrom6.vue'),
            meta: {
                auth: false,
                metaTitle: '辦理復繳',
                pageTitle: '辦理復繳',
            },
        },
    ],
}];

// production 不要產生 uatRoutes 的頁面，跳轉至 NOTFOUND 頁面
if (isProdMode()) {
    uatRoutes = uatRoutes.map(route => {
        return {
            path: route.path,
            redirect: routeName.NOTFOUND,
        };
    });
}
export default uatRoutes;
